import {AnyEventObject, fromCallback, type EventObject} from 'xstate'
import { Create_Game_Response_Message } from '@quiz-buzz/common/src/messages_from_server'
import { Websocket_Event_Names } from './types'

function getWebSocket(url: string): WebSocket {
	return new WebSocket(url)
}



export const websocketCallback = fromCallback(({sendBack, receive}) => {

	let websocket: WebSocket

	let connection_ping_repeating_task_id: NodeJS.Timeout | undefined


	const request_create_server = async (message: AnyEventObject) => {
		const response = await fetch('/api/create-game', {
			method: "POST",
			body: JSON.stringify(message)
		})
		const response_message = await response.json() as Create_Game_Response_Message
		return response_message
	}

	const connect = (game_code: string) => {
		console.log('init websocket')
		websocket = getWebSocket("/api/v1?game_code=" + game_code)

		websocket.onopen = function (this: WebSocket) {
			try {
				sendBack({type: Websocket_Event_Names.websocket_opened})
			}
			catch (e) {
				console.log('error trying to send event back to owning actor: ', e.message)
			}
			connection_ping_repeating_task_id = setInterval(() => {
				websocket.send(JSON.stringify({ type: 'ping' }))
			}, 5000)
		}
		websocket.onmessage = function (this: WebSocket, ev) {
			try {
				console.log('event from server: ', ev.data)
				const data = JSON.parse(ev.data.toString())
				if (data.type === 'pong') {
					return
				}
				sendBack(new CustomEvent(data.type, {detail: data.detail}))
			} catch (e) {
				sendBack(new CustomEvent('invalid_server_response'))
			}
		}
		websocket.onclose = function (this: WebSocket) {
			console.log('websocket close handler')
			clearInterval(connection_ping_repeating_task_id)
			connection_ping_repeating_task_id = undefined
			sendBack({type: Websocket_Event_Names.websocket_closed})
		}
		websocket.onerror = function (this: WebSocket, ev) {
			console.log('websocket error ', ev)
			sendBack({type: Websocket_Event_Names.websocket_error, detail: ev})
		}
	}

	// When this websocket actor receives an XSTATE event from a
	// parent actor it will send it over the WEBSOCKET connection
	receive((event: AnyEventObject) => {
		if (event.type === Websocket_Event_Names.create_new_server) {
			request_create_server(event).then(message => sendBack(message))
		}
		if (event.type === Websocket_Event_Names.client_request_disconnect) {
			console.log('client request disconnect, closing websocket')
			clearInterval(connection_ping_repeating_task_id)
			websocket.close()
			sendBack({type: Websocket_Event_Names.websocket_closed})
		}
		if (event.type === Websocket_Event_Names.connect_websocket) {
			connect(event.detail.game_code)
			
		} else {
			if (websocket) {
				websocket.send(format_event_for_websocket(event))
			}
		}
	})
})

function format_event_for_websocket(event: EventObject) {
	return JSON.stringify({
		type: event.type,
		detail: (event as CustomEvent).detail,
	})
}
